import {
  CheckScannerUiResult,
  CheckScanningResult,
  handleImageInput,
  mapRTUUIResult,
  withSBErrorHandling,
  type CheckScannerConfiguration,
  type CheckScannerScreenConfiguration,
  type ImageInput,
  type ResultWrapper,
} from '../types';

import { ScanbotSDKPlugin } from './Definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotCheckImpl = {
  async scanFromImage(params: {
    image: ImageInput;
    configuration: CheckScannerConfiguration;
  }): Promise<CheckScanningResult> {
    return withSBErrorHandling(
      async () =>
        new CheckScanningResult(
          await ScanbotSDKPlugin.scanCheckFromImage({
            configuration: params.configuration,
            image: handleImageInput(params.image),
          }),
        ),
    );
  },

  async startScanner(configuration: CheckScannerScreenConfiguration): Promise<ResultWrapper<CheckScannerUiResult>> {
    return withSBErrorHandling(async () =>
      mapRTUUIResult<CheckScannerUiResult>(
        await ScanbotSDKPlugin.startCheckScanner(configuration),
        CheckScannerUiResult,
      ),
    );
  },
};
